
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import Enquiries from "./Enquiries";
import AdminUsers from "./AdminUsers";
import UploadPhoto from "./UploadPhoto";
import UploadVideo from "./UploadVideo";
import AddPooja from "./AddPooja";
import AddFestival from "./AddFestival";
import ManageGallery from "./ManageGallery";
import PaymentReports from "./PaymentReports";
import FestivalRecords from "./FestivalRecords";
import PoojaRecords from "./PoojaRecords";
import MediaTV from "./MediaTV";

import "../Styles/Dashboard.css";

function Dashboard() {

  const navigate = useNavigate();

  const [activeMenu, setActiveMenu] = useState("dashboard");

  const [dashboardCounts, setDashboardCounts] = useState({
    photos: 0,
    videos: 0,
    festivals: 0,
    poojas: 0,
    enquiries: 0,
     mediaTV: 0
  });


  /* =====================================================
     LOAD DASHBOARD COUNTS
  ===================================================== */

  const loadDashboardCounts = async () => {

    try {

      const [
        photosResponse,
        videosResponse,
        festivalsResponse,
        poojasResponse,
        enquiriesResponse
      ] = await Promise.all([

        axios.get(
          "/api/gallery/images"
        ),

        axios.get(
          "/api/gallery/videos"
        ),

        axios.get(
          "/api/festivals"
        ),

        axios.get(
          "/api/poojas"
        ),

        axios.get(
          "/api/enquiries"
        ),
        axios.get("/api/media-tv/all")

      ]);


      setDashboardCounts({

        photos: photosResponse.data.length,

        videos: videosResponse.data.length,

        festivals: festivalsResponse.data.length,

        poojas: poojasResponse.data.length,

        enquiries: enquiriesResponse.data.length,
        

      });

    } catch (error) {

      console.error(
        "Error loading dashboard counts:",
        error
      );

    }

  };


  /* =====================================================
     LOAD COUNTS WHEN DASHBOARD OPENS
  ===================================================== */

  useEffect(() => {

    loadDashboardCounts();

  }, []);


  /* =====================================================
     MENU CLICK
  ===================================================== */

  const handleMenuClick = (menu) => {

    setActiveMenu(menu);

    loadDashboardCounts();

  };


  /* =====================================================
     LOGOUT
  ===================================================== */

  const handleLogout = () => {

    localStorage.removeItem("admin");

    navigate("/login");

  };


  /* =====================================================
     MIDDLE CONTENT
  ===================================================== */

  const renderMiddleContent = () => {

    switch (activeMenu) {

      /* ================================================
         ADMIN USERS
      ================================================ */

      case "admin-users":
        return (
          <AdminUsers
            refreshDashboard={loadDashboardCounts}
          />
        );


      /* ================================================
         UPLOAD PHOTO
      ================================================ */

      case "upload-photo":
        return (
          <UploadPhoto
            refreshDashboard={loadDashboardCounts}
          />
        );


      /* ================================================
         UPLOAD VIDEO
      ================================================ */

      case "upload-video":
        return (
          <UploadVideo
            refreshDashboard={loadDashboardCounts}
          />
        );


      /* ================================================
         ADD POOJA
      ================================================ */

      case "add-pooja":
        return (
          <AddPooja
            refreshDashboard={loadDashboardCounts}
          />
        );


      /* ================================================
         ADD FESTIVAL
      ================================================ */

      case "add-festival":
        return (
          <AddFestival
            refreshDashboard={loadDashboardCounts}
          />
        );


      /* ================================================
         PHOTOS
      ================================================ */

      case "photos":
        return (
          <ManageGallery
            view="photos"
            refreshDashboard={loadDashboardCounts}
          />
        );


      /* ================================================
         VIDEOS
      ================================================ */

      case "videos":
        return (
          <ManageGallery
            view="videos"
            refreshDashboard={loadDashboardCounts}
          />
        );


      /* ================================================
         MANAGE GALLERY
      ================================================ */

      case "manage-gallery":
        return (
          <ManageGallery
            view="all"
            refreshDashboard={loadDashboardCounts}
          />
        );


        case "media-tv":
    return (
        <MediaTV
            adminMode={true}
            refreshDashboard={loadDashboardCounts}
        />
    );

      /* ================================================
         FESTIVAL RECORDS
      ================================================ */

      case "festival-records":
        return <FestivalRecords />;


      /* ================================================
         POOJA RECORDS
      ================================================ */

      case "pooja-records":
        return <PoojaRecords />;


      /* ================================================
         PAYMENT REPORTS
      ================================================ */

      case "payment-reports":
        return <PaymentReports />;


      /* ================================================
         ENQUIRIES
      ================================================ */

      case "enquiries":
        return <Enquiries />;


      /* ================================================
         DEFAULT DASHBOARD
      ================================================ */

      default:
        return (
          <div className="welcome-content">

            <h2>
              📊 Welcome to Admin Dashboard
            </h2>

            <p>
              Select an option from the menu
              to manage the temple.
            </p>

          </div>
        );

    }

  };


  return (

    <div className="dashboard-container">

      <div className="dashboard-layout">


        {/* =================================================
            LEFT MENU
        ================================================= */}

        <div className="dashboard-menu">


          {/* Dashboard */}

          <button
            className={
              activeMenu === "dashboard"
                ? "dashboard-menu-dashboard active-menu"
                : "dashboard-menu-dashboard"
            }

            onClick={() =>
              handleMenuClick("dashboard")
            }
          >

            📊 Dashboard

          </button>


          <div className="menu-list">


            {/* Admin Users */}

            <button
              className={
                activeMenu === "admin-users"
                  ? "menu-item active-menu"
                  : "menu-item"
              }

              onClick={() =>
                handleMenuClick("admin-users")
              }
            >

              👤 Admin Users

            </button>


            {/* Upload Photo */}

            <button
              className={
                activeMenu === "upload-photo"
                  ? "menu-item active-menu"
                  : "menu-item"
              }

              onClick={() =>
                handleMenuClick("upload-photo")
              }
            >

              📷 Upload Photo

            </button>


            {/* Upload Video */}

            <button
              className={
                activeMenu === "upload-video"
                  ? "menu-item active-menu"
                  : "menu-item"
              }

              onClick={() =>
                handleMenuClick("upload-video")
              }
            >

              🎥 Upload Video

            </button>


            {/* Add Pooja */}

            <button
              className={
                activeMenu === "add-pooja"
                  ? "menu-item active-menu"
                  : "menu-item"
              }

              onClick={() =>
                handleMenuClick("add-pooja")
              }
            >

              🙏 Add Pooja

            </button>


            {/* Add Festival */}

            <button
              className={
                activeMenu === "add-festival"
                  ? "menu-item active-menu"
                  : "menu-item"
              }

              onClick={() =>
                handleMenuClick("add-festival")
              }
            >

              🪔 Add Festival

            </button>


            {/* Manage Gallery */}

            <button
              className={
                activeMenu === "manage-gallery"
                  ? "menu-item active-menu"
                  : "menu-item"
              }

              onClick={() =>
                handleMenuClick("manage-gallery")
              }
            >

              🖼️ Manage Gallery

            </button>


              <button
    className={
        activeMenu === "media-tv"
            ? "menu-item active-menu"
            : "menu-item"
    }
    onClick={() =>
        handleMenuClick("media-tv")
    }
>
    📺 Media TV
</button>
            {/* Payment Reports */}

            <button
              className={
                activeMenu === "payment-reports"
                  ? "menu-item active-menu"
                  : "menu-item"
              }

              onClick={() =>
                handleMenuClick("payment-reports")
              }
            >

              ₹ Payment Reports

            </button>


            {/* Logout */}

            <button
              className="menu-item logout-menu"

              onClick={handleLogout}
            >

              🚪 Logout

            </button>


          </div>

        </div>


        {/* =================================================
            MIDDLE CONTENT
        ================================================= */}

        <div className="middle-content">

          {renderMiddleContent()}

        </div>


        {/* =================================================
            RIGHT DASHBOARD
        ================================================= */}

        <div className="right-dashboard">

          <h2>
            Dashboard Summary
          </h2>
            {/*Media TV */}

            <button
                className="summary-item media-tv-summary"
                onClick={() =>
                    setActiveMenu("media-tv")
                }
            >
                <h3>
                    {dashboardCounts.mediaTV}
                </h3>

                <p>
                    Media TV
                </p>
            </button>

          {/* Photos */}

          <button
            className="summary-item photos"
            onClick={() =>
              setActiveMenu("photos")
            }
          >

            <h3>
              {dashboardCounts.photos}
            </h3>

            <p>
              Photos
            </p>

          </button>


          {/* Videos */}

          <button
            className="summary-item videos"
            onClick={() =>
              setActiveMenu("videos")
            }
          >

            <h3>
              {dashboardCounts.videos}
            </h3>

            <p>
              Videos
            </p>

          </button>


          {/* Festivals */}

          <button
            className="summary-item festivals"
            onClick={() =>
              setActiveMenu("festival-records")
            }
          >

            <h3>
              {dashboardCounts.festivals}
            </h3>

            <p>
              Festivals
            </p>

          </button>


          {/* Poojas */}

          <button
            className="summary-item poojas"
            onClick={() =>
              setActiveMenu("pooja-records")
            }
          >

            <h3>
              {dashboardCounts.poojas}
            </h3>

            <p>
              Poojas
            </p>

          </button>


          {/* Enquiries */}

          <button
            className="summary-item enquiry"
            onClick={() =>
              setActiveMenu("enquiries")
            }
          >

            <h3>
              {dashboardCounts.enquiries}
            </h3>

            <p>
              Enquiries
            </p>

          </button>


        </div>


      </div>

    </div>

  );

}

export default Dashboard;
